var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('h1',[_vm._v(_vm._s(_vm.pageNotFound))])])
}
var staticRenderFns = []

export { render, staticRenderFns }